<div class="main-panel" *ngIf="currentStep" [@inOutAnimation]>
	<div style="color: #FFF; padding: 30px;">
		<div style="position: absolute; right: 19px; top: 59px; font-size: 22px;">
			<button mat-icon-button (click)="close()">
				<span class="fal fa-close" style="font-size: 22px;"></span>
			</button>
		</div>
		<div style="font-size: 18px; font-weight: 700">{{ currentStep.functionName }}</div>
		<div style="padding-top: 20px; font-size: 16px;">
			<div style="padding: 10px 0;">
				<span style="font-weight: 700;">Case: </span>
				<span>{{ currentStep.caseName }}</span>
				<span class="fal fa-copy" style="padding-left: 10px; cursor: pointer;" (click)="copyCaseIdToClipboard()"></span>
			</div>
			<div style="padding: 10px 0;">
				<span style="font-weight: 600;">Server: </span>
				<span>{{ currentStep.serverInstanceName }} ({{ currentStep.serverIpAddress }})</span>
			</div>
			<div style="padding: 10px 0;">
				<span style="font-weight: 600;">Started: </span>
				<span>{{ currentStep.createdDateTime }}</span>
			</div>
			<div style="padding: 10px 0;" *ngIf="currentStep.documentId">
				<span style="font-weight: 600;">Document: </span>
				<span>{{ currentStep.documentName }}</span>
				<span class="fal fa-copy" style="padding-left: 10px; cursor: pointer;" (click)="copyDocumentIdToClipboard()"></span>
			</div>
			<div style="padding: 10px 0;">
				<span style="font-weight: 600;">Page Count: </span>
				<span>{{ currentStep.pageCount }}</span>
			</div>
		</div>
	</div>
	<div style="color: #FFF;">
		<hr style="border: 1px solid #E0E0E00A">
		<div style="padding: 20px 30px; font-size: 16px;">
			<span style="font-weight: 600;">Processing Step Params </span>
			<span class="fal fa-copy" style="padding-left: 10px; cursor: pointer;" (click)="copyParamsToClipboard()"></span>
			<pre style="background: #343434; padding: 10px; overflow: auto; min-height: 420px;">{{ currentStep.stepParams | json }}</pre>
		</div>
	</div>
</div>
